import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationDocuments } from 'modules/accommodations/features/reservations/api';

interface IProps {
  reservationId: string;
}

export const useQueryReservationDocuments = ({ reservationId }: IProps) => {
  const { isLoading, isError, data } = useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_DOCUMENTS, reservationId],
    () => getCalculationDocuments(reservationId),
  );

  return {
    isLoading,
    isError,
    data,
  };
};
